// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3exXm","label":"CategoryService_label__MjQww","location":"CategoryService_location__3BfK_"};